import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Calendar from './pages/Calendar';
import Patients from './pages/Patients';
import Appointments from './pages/Appointments';
import Schedule from './pages/Schedule';
import History from './pages/History';
import Users from './pages/Users';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
                                <Route path="/" element={
                      <ProtectedRoute>
                        <Layout>
                          <Calendar />
                        </Layout>
                      </ProtectedRoute>
                    } />
                    <Route path="/dashboard" element={
                      <ProtectedRoute>
                        <Layout>
                          <Dashboard />
                        </Layout>
                      </ProtectedRoute>
                    } />
            <Route path="/patients" element={
              <ProtectedRoute allowedRoles={['dispatcher']}>
                <Layout>
                  <Patients />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/appointments" element={
              <ProtectedRoute allowedRoles={['dispatcher']}>
                <Layout>
                  <Appointments />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/schedule" element={
              <ProtectedRoute allowedRoles={['doctor']}>
                <Layout>
                  <Schedule />
                </Layout>
              </ProtectedRoute>
            } />
                                <Route path="/history" element={
                      <ProtectedRoute>
                        <Layout>
                          <History />
                        </Layout>
                      </ProtectedRoute>
                    } />
                    <Route path="/users" element={
                      <ProtectedRoute allowedRoles={['admin']}>
                        <Layout>
                          <Users />
                        </Layout>
                      </ProtectedRoute>
                    } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App; 